export default class Photo {
  uid: string;
  href: string;
}
